export default [
  {
    name: 'sim-card-create',
    path: '/sim-cards/create',
    component: () => import('@/views/sim-cards/SimCardManage')
  },
  {
    name: 'sim-card-edit',
    path: '/sim-cards/:id/edit',
    component: () => import('@/views/sim-cards/SimCardManage')
  },
  {
    name: 'sim-card-view',
    path: '/sim-cards/:id/view',
    component: () => import('@/views/sim-cards/SimCardManage')
  },
  {
    name: 'sim-card-find',
    path: '/sim-cards/find',
    component: () => import('@/views/sim-cards/SimCardFind')
  }
]



// WEBPACK FOOTER //
// ./src/router/routeSimCards.js